import { createSelector } from 'reselect';

export const getTotalMatches = createSelector(
  [({ searchAndBrowse } = {}) => searchAndBrowse],
  ({ totalMatches = 0 } = {}) => totalMatches,
);
